module.exports = __webpack_public_path__ + "img/publication-gelb-neu.24ee77e9.svg";